/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export const MetricsDatapointFieldSourceType = {
    Dataset: "Dataset",
};
export const MetricsDatapointFieldType = {
    Integer: "Integer",
    Float: "Float",
    Boolean: "Boolean",
    String: "String",
    Class: "Class",
    Datetime: "Datetime",
    UUID: "UUID",
    SampleIDs: "Sample IDs",
};
export const MetricsMetricWidget = {
    Scalar: "Scalar",
    Line: "Line",
    ConfusionMatrix: "Confusion Matrix",
    Bar: "Bar",
    Histogram: "Histogram",
    ROC: "ROC",
    ScoreGraph: "Score Graph",
    Percentage: "Percentage",
};
import axios from "axios";
import qs from "qs";
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = async ({ secure, path, type, query, format, body, ...params }) => {
            const secureParams = ((typeof secure === "boolean" ? secure : this.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = format || this.format || undefined;
            if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
                body = this.createFormData(body);
            }
            if (type === ContentType.UrlEncoded && body && body !== null && typeof body === "object") {
                body = qs.stringify(body);
            }
            if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
                body = JSON.stringify(body);
            }
            return this.instance.request({
                ...requestParams,
                headers: {
                    ...(requestParams.headers || {}),
                    ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
                },
                params: query,
                responseType: responseFormat,
                data: body,
                url: path,
            });
        };
        this.instance = axios.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || "",
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "indices" }),
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method && this.instance.defaults.headers[method.toLowerCase()]) || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
}
/**
 * @title RVAI Metrics Service
 * @version 0.1.0
 */
export class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.livez = {
            /**
             * @description Get application heartbeat.
             *
             * @tags monitor
             * @name GetHeartbeat
             * @summary Get Heartbeat
             * @request GET:/livez
             * @secure
             */
            getHeartbeat: (params = {}) => this.request({
                path: `/livez`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.metrics = {
            /**
             * @description List all registered metric types. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags metrics
             * @name ListMetricTypes
             * @summary List Metric Types
             * @request GET:/metrics
             * @secure
             */
            listMetricTypes: (query, params = {}) => this.request({
                path: `/metrics`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Create new metric type. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags metrics
             * @name CreateMetricType
             * @summary Create Metric Type
             * @request POST:/metrics
             * @secure
             */
            createMetricType: (data, params = {}) => this.request({
                path: `/metrics`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description List all metric type fields. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags metrics
             * @name ListMetricTypeFields
             * @summary List Metric Type Fields
             * @request GET:/metrics/fields
             * @secure
             */
            listMetricTypeFields: (params = {}) => this.request({
                path: `/metrics/fields`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Delete metric runs. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags metric runs
             * @name DeleteMetricRuns
             * @summary Delete Metric Runs
             * @request DELETE:/metrics/runs
             * @secure
             */
            deleteMetricRuns: (query, params = {}) => this.request({
                path: `/metrics/runs`,
                method: "DELETE",
                query: query,
                secure: true,
                ...params,
            }),
            /**
             * @description List metric runs. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags metric runs
             * @name ListMetricRuns
             * @summary List Metric Runs
             * @request GET:/metrics/runs
             * @secure
             */
            listMetricRuns: (query, params = {}) => this.request({
                path: `/metrics/runs`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Create metric run for a source. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags metric runs
             * @name CreateMetricRun
             * @summary Create Metric Run
             * @request POST:/metrics/runs
             * @secure
             */
            createMetricRun: (data, params = {}) => this.request({
                path: `/metrics/runs`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description List all metric run fields. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags metric runs
             * @name ListMetricRunsFields
             * @summary List Metric Runs Fields
             * @request GET:/metrics/runs/fields
             * @secure
             */
            listMetricRunsFields: (params = {}) => this.request({
                path: `/metrics/runs/fields`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get SSE updates for new/updated metric runs for source. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags metric runs
             * @name GetMetricRunsUpdates
             * @summary Get Metric Runs Updates
             * @request GET:/metrics/runs/updates
             * @secure
             */
            getMetricRunsUpdates: (query, params = {}) => this.request({
                path: `/metrics/runs/updates`,
                method: "GET",
                query: query,
                secure: true,
                ...params,
            }),
            /**
             * @description Delete metric run. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags metric runs
             * @name DeleteMetricRun
             * @summary Delete Metric Run
             * @request DELETE:/metrics/runs/{run_id}
             * @secure
             */
            deleteMetricRun: (runId, params = {}) => this.request({
                path: `/metrics/runs/${runId}`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get metric run. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags metric runs
             * @name GetMetricRun
             * @summary Get Metric Run
             * @request GET:/metrics/runs/{run_id}
             * @secure
             */
            getMetricRun: (runId, params = {}) => this.request({
                path: `/metrics/runs/${runId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Add datapoints to metric run. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags metric runs
             * @name AddMetricRunDatapoints
             * @summary Add Metric Run Datapoints
             * @request POST:/metrics/runs/{run_id}
             * @secure
             */
            addMetricRunDatapoints: (runId, data, params = {}) => this.request({
                path: `/metrics/runs/${runId}`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),
            /**
             * @description Get datapoints for metric. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags metric runs
             * @name GetMetricRunDatapoints
             * @summary Get Metric Run Datapoints
             * @request GET:/metrics/runs/{run_id}/datapoints
             * @secure
             */
            getMetricRunDatapoints: (runId, query, params = {}) => this.request({
                path: `/metrics/runs/${runId}/datapoints`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get datapoint field for metric. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags metric runs
             * @name GetMetricRunDatapointField
             * @summary Get Metric Run Datapoint Field
             * @request GET:/metrics/runs/{run_id}/datapoints/{datapoint_id}/{field_id}
             * @secure
             */
            getMetricRunDatapointField: (runId, datapointId, fieldId, query, params = {}) => this.request({
                path: `/metrics/runs/${runId}/datapoints/${datapointId}/${fieldId}`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Delete a metric type. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags metrics
             * @name DeleteMetricType
             * @summary Delete Metric Type
             * @request DELETE:/metrics/{metric_id}
             * @secure
             */
            deleteMetricType: (metricId, query, params = {}) => this.request({
                path: `/metrics/${metricId}`,
                method: "DELETE",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get metric type. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags metrics
             * @name GetMetricType
             * @summary Get Metric Type
             * @request GET:/metrics/{metric_id}
             * @secure
             */
            getMetricType: (metricId, params = {}) => this.request({
                path: `/metrics/${metricId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Update mutable metric type fields. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags metrics
             * @name UpdateMetricType
             * @summary Update Metric Type
             * @request PATCH:/metrics/{metric_id}
             * @secure
             */
            updateMetricType: (metricId, data, params = {}) => this.request({
                path: `/metrics/${metricId}`,
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
        };
        this.prometheus = {
            /**
             * No description
             *
             * @tags monitor
             * @name GetPrometheusMetrics
             * @summary Get Prometheus Metrics
             * @request GET:/prometheus
             * @secure
             */
            getPrometheusMetrics: (params = {}) => this.request({
                path: `/prometheus`,
                method: "GET",
                secure: true,
                ...params,
            }),
        };
        this.telemetry = {
            /**
             * @description List the values a given label takes in the stored telemetry. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags telemetry
             * @name ListTelemetryLabelValues
             * @summary List Telemetry Label Values
             * @request GET:/telemetry/label/{label_name}/values
             * @secure
             */
            listTelemetryLabelValues: (labelName, params = {}) => this.request({
                path: `/telemetry/label/${labelName}/values`,
                method: "GET",
                secure: true,
                ...params,
            }),
            /**
             * @description Forward a read query to VictoriaMetrics and return its response. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags telemetry
             * @name QueryTelemetry
             * @summary Query Telemetry
             * @request GET:/telemetry/{vm_path}
             * @secure
             */
            queryTelemetry: (vmPath, params = {}) => this.request({
                path: `/telemetry/${vmPath}`,
                method: "GET",
                secure: true,
                ...params,
            }),
        };
        this.version = {
            /**
             * @description Get application version.
             *
             * @tags monitor
             * @name GetVersion
             * @summary Get Version
             * @request GET:/version
             * @secure
             */
            getVersion: (params = {}) => this.request({
                path: `/version`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
    }
}
//# sourceMappingURL=data:application/json;base64,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